import { useEffect } from "react";
import { NOTIFICATIONS } from "../../../constants/constants";
import { API_NOTIFICATIONS } from "../../../constants/apis";
import { useTitle } from "../../../hooks/common/useTitle";
import { ListHandler, reloadData } from "../../lists/ListHandler";
import { updateGlobalContext } from "../../context/GlobalContext";
import useSet from "../../../hooks/common/useSet";

/**
 * Visiting the notifications page == "I've seen these". Fire a one-shot
 * mark-all-as-read so the bell badge drops to 0 immediately. Idempotent:
 * if everything is already read, the backend just returns count=0.
 */
export const NotificationsPage = () => {
  useTitle("Notifications");
  const { uploadData } = useSet();

  useEffect(() => {
    uploadData({
      api: `${API_NOTIFICATIONS}read-all/`,
      method: "POST",
      params: {},
      successMessage: false,
      onSuccess: () => {
        // Refresh the list so the visited items dim, and bump the
        // global flag so the AppBar bell refetches the unread count.
        reloadData(NOTIFICATIONS);
        updateGlobalContext({ reload_notifications: new Date() });
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p15">
      <ListHandler source={NOTIFICATIONS} />
    </div>
  );
};